import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuStore {
  public viewMenuActive = new BehaviorSubject<boolean>(false);
}
